export default __webpack_public_path__ + "static/4-e598d6cb497f5688b8ea2a49a849d575.png";